import { PROGRESS_STEP_KINDS } from '@/config/constants';
import progressDate from '@/services/progressDate';

const DEFAULT_ICON = 'fas fa-file';

// The only files LIMS accepts on a stability: PDF protocols, and PDF or Excel time point files
// (photos are embedded in the spreadsheet).
const ICONS = {
  'application/pdf': 'fas fa-file-pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'fas fa-file-excel',
};

export default {
  icon({ mediaType }) {
    return ICONS[mediaType] || DEFAULT_ICON;
  },
  date({ occurredAt }) {
    return progressDate.dateTime(occurredAt);
  },
  // The completed step closes the sample: it lists every file, any other step only its own.
  ofStep(files, { stepId, kind }) {
    return kind === PROGRESS_STEP_KINDS.COMPLETED
      ? files
      : files.filter(file => file.stepId === stepId);
  },
};
